export default {
  data() {
    return {
      // eslint-disable-next-line
      accessLevelFacility: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
      ],
      // eslint-disable-next-line
      accessLevelCompany: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
      ]
    };
  }
};
